module.exports = __webpack_public_path__ + "img/gy.255d1d57.jpg";